/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { ListUserTypesQueryResponse } from '../../types/ListUserTypes'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listUserTypes } from '../../clients/listUserTypes'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listUserTypesQueryKey = () =>
  [{ url: '/api/v1/users/user-types/' }] as const

export type ListUserTypesQueryKey = ReturnType<typeof listUserTypesQueryKey>

export function listUserTypesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listUserTypesQueryKey()
  return queryOptions<
    ListUserTypesQueryResponse,
    ResponseErrorConfig<Error>,
    ListUserTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listUserTypes({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @description API endpoint for listing available user types.
 * Architecture: READ operation - returns the list of valid user type names.
 * Only Admin users with manage_user_types permission can access this endpoint.
 * @summary List assignable user types
 * {@link /api/v1/users/user-types/}
 */
export function useListUserTypes<
  TData = ListUserTypesQueryResponse,
  TQueryData = ListUserTypesQueryResponse,
  TQueryKey extends QueryKey = ListUserTypesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListUserTypesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listUserTypesQueryKey()

  const query = useQuery(
    {
      ...listUserTypesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
